module.exports = __webpack_public_path__ + "assets/img/icon5-menu.78ea62b1.svg";